import { Navigate, useNavigate } from 'react-router-dom';
import { useControllerSocialMediaContext } from '../../hooks/ControllerSocialMedia';
import { useEffect, useState } from 'react';
import RedirectLoader from './RedirectLoader';
import {
  getSocialErrorRouteFromStorage,
  isSocialRecoveryFlow,
  pushGtmEvent
} from '../../utils/GenericFunctions';

async function exchangeCodeForToken(code: string): Promise<string> {
  const clientId =
    process.env.REACT_APP_MICROSOFT_CLIENT_ID ||
    'f58e9113-394a-41a7-ba95-c837294dfcb9';
  const codeVerifier = sessionStorage.getItem('ms_code_verifier') || '';
  const redirectUri = sessionStorage.getItem('ms_redirect_uri') || '';

  const body = new URLSearchParams({
    client_id: clientId,
    grant_type: 'authorization_code',
    code,
    redirect_uri: redirectUri,
    code_verifier: codeVerifier,
    scope: 'openid profile email User.Read'
  });

  const response = await fetch(
    'https://login.microsoftonline.com/common/oauth2/v2.0/token',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString()
    }
  );

  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.error_description || 'Token exchange failed');
  }

  const data = await response.json();

  sessionStorage.removeItem('ms_code_verifier');
  sessionStorage.removeItem('ms_redirect_uri');

  return data.access_token;
}

export default function MicrosoftRedirect() {
  const { loginMicrosoft } = useControllerSocialMediaContext();
  const navigate = useNavigate();
  const [hasCode, setHasCode] = useState(false);

  const params = new URLSearchParams(window.location.search);
  const code = params.get('code');

  useEffect(() => {
    console.log('code', code);
    if (!code) {
      if (isSocialRecoveryFlow()) {
        pushGtmEvent('recovery_social_auth_cancel', { provider: 'microsoft' });
      }
      navigate(getSocialErrorRouteFromStorage(), {
        state: { socialConnectionError: true },
        replace: true
      });
      return;
    }

    // window.history.replaceState(null, '', window.location.pathname);
    setHasCode(true);

    exchangeCodeForToken(code)
      .then((accessToken) => {
        if (isSocialRecoveryFlow()) {
          pushGtmEvent('recovery_social_auth_success', {
            provider: 'microsoft'
          });
        }
        loginMicrosoft(accessToken);
      })
      .catch((error) => {
        console.error('Microsoft token exchange error:', error);
        if (isSocialRecoveryFlow()) {
          pushGtmEvent('recovery_social_auth_cancel', {
            provider: 'microsoft'
          });
        }
        navigate(getSocialErrorRouteFromStorage(), {
          state: { socialConnectionError: true },
          replace: true
        });
      });
  }, []);

  if (!code && !hasCode)
    return (
      <Navigate
        to={getSocialErrorRouteFromStorage()}
        state={{ socialConnectionError: true }}
        replace
      />
    );

  return <RedirectLoader />;
}
